import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { api, formatApiError } from "@/lib/api";
import { Brand } from "@/components/Brand";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [check, setCheck] = useState(null); // null = verificando
  const [pw, setPw] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/auth/reset-password/${token}`)
      .then((r) => setCheck(r.data))
      .catch((e) => setCheck({ valid: false, error: formatApiError(e.response?.data?.detail) }));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw !== confirm) return setError("A confirmação não confere com a nova senha.");
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success(check.first_access ? "Acesso criado! Entre com seu e-mail e a senha." : "Senha redefinida! Entre com a nova senha.");
      navigate("/login", { replace: true });
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center p-6 bg-[#F8FAFC]">
      <div className="w-full max-w-sm bg-white border border-slate-200 rounded-2xl p-8 animate-fade-up">
        <Brand size="md" className="mb-6" />
        {check === null ? (
          <div className="grid place-items-center py-8"><Loader2 className="h-6 w-6 animate-spin text-slate-400" /></div>
        ) : !check.valid ? (
          <>
            <h2 className="font-display text-2xl font-bold text-slate-900">Link inválido</h2>
            <p className="text-slate-500 text-sm mt-2">{check.error || "Este link expirou ou já foi usado."}</p>
            <Link to="/esqueci-senha" className="inline-block text-sm font-semibold text-[#1E9E2A] mt-6 hover:underline">Solicitar um novo link →</Link>
          </>
        ) : (
          <>
            <h2 className="font-display text-2xl font-bold text-slate-900">{check.first_access ? "Criar sua senha de acesso" : "Criar nova senha"}</h2>
            <p className="text-slate-500 text-sm mt-2 mb-6">
              {check.first_access && "Bem-vindo(a) à nova plataforma do IEP! "}Conta: <strong>{check.email}</strong>
            </p>
            <form onSubmit={submit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="rp-new">Nova senha</Label>
                <Input id="rp-new" type="password" autoComplete="new-password" minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} required className="h-11" data-testid="reset-password-input" />
              </div>
              <div className="space-y-2">
                <Label htmlFor="rp-conf">Confirmar nova senha</Label>
                <Input id="rp-conf" type="password" autoComplete="new-password" minLength={8} value={confirm} onChange={(e) => setConfirm(e.target.value)} required className="h-11" />
              </div>
              <p className="text-xs text-slate-400">Mínimo de 8 caracteres.</p>
              {error && <div className="text-sm text-red-600 bg-red-50 border border-red-100 rounded-lg px-3 py-2">{error}</div>}
              <Button type="submit" disabled={loading} className="w-full h-11 text-white font-semibold" style={{ background: "#232D4F" }} data-testid="reset-submit-button">
                {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Salvar nova senha"}
              </Button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
